import { defineStore } from "pinia";
import { Shop } from "@src/api";

type UserInfoState = {
  shop: Shop | null;
};

const stateDefault: UserInfoState = {
  shop: null,
};

export const useUserInfoStore = defineStore("userInfo", {
  state: () => stateDefault,
  actions: {
    setShop(shop: Shop) {
      this.shop = shop;
    },
    clearShop() {
      this.shop = null;
    },
    reset() {
      Object.keys(stateDefault).forEach((key) => {
        this[key] = stateDefault[key];
      });
    },
  },
  getters: {
    store_types: (state) => {
      const store_types: string[] = [];

      if (state.shop?.store_types.shoes) store_types.push("shoes");
      if (state.shop?.store_types.underwear) store_types.push("underwear");
      if (state.shop?.store_types.accessories) store_types.push("accessories");
      if (state.shop?.store_types.clothing) store_types.push("clothing");

      return store_types;
    },
  },
});
